import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
	redirect: '/index', //重定向
    component: () => import('../views/index.vue'),
	children: [
		{
			path: '/index',
			name: 'index',
			meta: { title: '首页' },
			component: () => import('../views/index.vue')
		}
	]
  },
  {
  	path: '/addbaodan',
  	name: 'addbaodan',
  	meta: { title: '完善信息' },
  	component: () => import('../views/addbaodan/addbaodan.vue')
  },
  {
  	path: '/otherform',
  	name: 'otherform',
  	meta: { title: '其他产品报单' },
  	component: () => import('../views/otherform/otherform.vue')
  },
  {
  	path: '/chengxintongform',
  	name: 'chengxintongform',
  	meta: { title: '诚信通报单' },
  	component: () => import('../views/chengxintongform/chengxintongform.vue')
  },
  {
  	path: '/NetxiaoBao',
  	name: 'NetxiaoBao',
  	meta: { title: '网销宝' },
  	component: () => import('../views/NetxiaoBao/NetxiaoBao.vue')
  },
  {
  	path: '/goback',
  	name: 'goback',
  	meta: { title: '已确认诚信通' },
  	component: () => import('../views/goback/goback.vue')
  },
  {
  	path: '/mymenu',
  	name: 'mymenu',
  	meta: { title: '我的' },
  	component: () => import('../views/mymenu/mymenu.vue')
  },
  {
  	path: '/analysis',
  	name: 'analysis',
  	meta: { title: '数据分析' },
  	component: () => import('../views/analysis/analysis.vue')
  },
  {
  	path: '/Orderdetails',
  	name: 'Orderdetails',
  	meta: { title: '订单详情' },
  	component: () => import('../views/Orderdetails/Orderdetails.vue')
  },
  {
  	path: '/Refunddetails',
  	name: 'Refunddetails',
  	meta: { title: '订单详情' },
  	component: () => import('../views/Refunddetails/Refunddetails.vue')
  },
  {
  	path: '/FollowInfor',
  	name: 'FollowInfor',
  	meta: { title: '跟单信息' },
  	component: () => import('../views/FollowInfor/FollowInfor.vue')
  },
  {
  	path: '/newkong',
  	name: 'newkong',
  	meta: { title: '已在浏览器打开' },
  	component: () => import('../views/newkong.vue')
  },
  {
  	path: '/noquanxian',
  	name: 'noquanxian',
  	meta: { title: '已在浏览器打开' },
  	component: () => import('../views/noquanxian.vue')
  }
];

const router = new VueRouter({
  routes,
});

export default router;
